import { defineStore } from 'pinia'

// stores
import { useSocketStore } from './SocketStore'

// Types
interface CallCenter {
  id: string
  name?: string
}

export const useCallCenterStore = defineStore('callCenterStore', {
  state: (): {
    callCenters: CallCenter[]
    selectedCallCenter: string | null
  } => ({
    callCenters: [],
    selectedCallCenter: null
  }),

  actions: {
    /**
     * Updates call centers and sets selected call center
     * @param callCenters - Array of call center objects
     */
    updateCallCenters(callCenters: CallCenter[]): void {
      this.callCenters = callCenters

      // Check that the ls item exists, else set it to empty
      if (
        !localStorage.getItem('callCenterSelected') ||
        localStorage.getItem('callCenterSelected') === 'null' ||
        localStorage.getItem('callCenterSelected') === 'undefined'
      ) {
        localStorage.setItem('callCenterSelected', '')
        localStorage.setItem('report-filter-call-center-selected', '')
      }

      // If no call centers, set ls item to null
      if (callCenters.length === 0) {
        localStorage.setItem('callCenterSelected', '')
        localStorage.setItem('report-filter-call-center-selected', '')
      } else {
        // Check if ls item isset (regardless of value), if not, set the first one in the array
        if (localStorage.getItem('callCenterSelected') || localStorage.getItem('callCenterSelected') === '') {
          // Set the selected call center to the one in the ls
          this.selectedCallCenter = localStorage.getItem('callCenterSelected')
          localStorage.setItem('report-filter-call-center-selected', localStorage.getItem('callCenterSelected') || '')
        } else {
          // else set the first one in the array
          this.selectedCallCenter = callCenters[0]?.id || null
          localStorage.setItem('callCenterSelected', callCenters[0]?.id || '')
          localStorage.setItem('report-filter-call-center-selected', callCenters[0]?.id || '')
        }
      }
    },

    /**
     * Selects a call center
     * @param callCenterId - ID of the call center to select
     */
    selectCallCenter(callCenterId: string | null): void {
      if (callCenterId === null) {
        this.selectedCallCenter = null
        localStorage.setItem('callCenterSelected', '')
        localStorage.setItem('report-filter-call-center-selected', '')
      } else {
        // Check that the call center exists in the array (to check that the user does have access to it)
        if (this.callCenters.some(callCenter => callCenter.id === callCenterId)) {
          this.selectedCallCenter = callCenterId
          localStorage.setItem('callCenterSelected', callCenterId)
        } else {
          this.selectedCallCenter = null
          localStorage.setItem('callCenterSelected', '')
          console.error('Call center not found in the array')
        }
      }

      // Notify socket store of the change
      const socketStore = useSocketStore()
      socketStore.emitCallCenterUpdate()
    }
  }
})
